import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem("blitzz-theme") || "dark");

  useEffect(() => {
    localStorage.setItem("blitzz-theme", theme);
    const root = document.documentElement;
    root.setAttribute("data-theme", theme);
    // Tailwind dark mode is class-based
    if (theme === "dark") {
      root.classList.add("dark");
      root.classList.remove("light");
    } else {
      root.classList.add("light");
      root.classList.remove("dark");
    }
  }, [theme]);

  const toggle = () => setTheme(t => t === "dark" ? "light" : "dark");
  const setLight = () => setTheme("light");
  const setDark = () => setTheme("dark");

  return (
    <ThemeContext.Provider value={{ theme, toggle, setLight, setDark, isDark: theme === "dark" }}>
      {children}
    </ThemeContext.Provider>
  );
};
